import { takeLatest } from 'redux-saga/effects';

import { CustomerDetailsSaga, downloadCustomerDetailsSaga } from './customerSaga';
import sagaActions from '../../actions/index';

export function* customerListSaga() {
  yield takeLatest(sagaActions.GET_CUSTOMER_DETILS, CustomerDetailsSaga);
  yield takeLatest(sagaActions.DOWNLOAD_CUSTOMER_DETILS, downloadCustomerDetailsSaga);
}
